module.exports = __webpack_public_path__ + "static/media/inflate.fdf40b9f.png";